var _excluded = ["triggerOnce"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useMemo, useRef } from "react";
var isValidThreshold = function isValidThreshold(threshold) {
  // A threshold does not have to be passed; the native
  // Intersection Observer API also takes "null" as a valid
  // parameter
  if (!threshold || threshold <= 1 && threshold >= 0) {
    return true;
  }
  return false;
};

/**
 * Creates an instance of an IntersectionObserver
 * to be used between renders.
 * @returns callback ref to be passed to a React element
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 * @see https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
 */
var defaultConfig = {
  triggerOnce: false
};
var useInView = function useInView(cb) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultConfig;
  var _config$triggerOnce = config.triggerOnce,
    triggerOnce = _config$triggerOnce === void 0 ? false : _config$triggerOnce,
    opts = _objectWithoutProperties(config, _excluded);
  // Prevent runtime errors associated with passing
  // invalid threshold values to the intersection
  // observer
  var validatedThreshold = useMemo(function () {
    var isValid = isValidThreshold(opts.threshold);
    if (!isValid) {
      console.warn("Invalid threshold passed for intersection observer; must be between 0 and 1. Defaulting to 0.");
      return 0;
    }
    return opts.threshold;
  }, [opts === null || opts === void 0 ? void 0 : opts.threshold]);
  var observerConfig = useMemo(function () {
    return _objectSpread(_objectSpread({}, opts), {}, {
      threshold: validatedThreshold
    });
  }, [opts, validatedThreshold]);
  var intersectionCount = useRef(0);
  var observedNodeRef = useRef();
  var observerRef = useRef();
  var handleChange = function handleChange(_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      entry = _ref2[0];
    if (triggerOnce && intersectionCount.current === 1) {
      return;
    }
    if (entry.isIntersecting) {
      intersectionCount.current += 1;
    }
    if (typeof cb === "function") {
      cb({
        inView: entry.isIntersecting,
        entry: entry
      });
    }
  };
  var unobserveTrackedRef = function unobserveTrackedRef() {
    if (!observedNodeRef.current) {
      return;
    }
    observerRef.current.unobserve(observedNodeRef.current);
    observerRef.current.disconnect();
  };
  var observeNode = function observeNode(node) {
    // Stay in sync with the DOM node reference
    // on the screen
    if (node !== observedNodeRef.current) {
      intersectionCount.current = 0;
    }
    observerRef.current = new IntersectionObserver(handleChange, observerConfig);
    observedNodeRef.current = node;
    observerRef.current.observe(node);
  };
  var callbackRef = function callbackRef(node) {
    node ? observeNode(node) : unobserveTrackedRef();
  };
  return callbackRef;
};
export default useInView;